var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dadosJson
    ? _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.abaAtiva,
                callback: function($$v) {
                  _vm.abaAtiva = $$v
                },
                expression: "abaAtiva"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticClass: "tab",
                  attrs: { name: "informacoesadministrativas" }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Informações Administrativas  ")
                  ]),
                  _c("informacoes-administrativas-uc", {
                    attrs: { dadosJson: _vm.dadosJson }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "atoslegais" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Atos Legais  ")
                  ]),
                  _c("atos-legais-uc", { attrs: { dadosJson: _vm.dadosJson } })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "contato" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Contato  ")
                  ]),
                  _c("contato-uc", { attrs: { dadosJson: _vm.dadosJson } })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { staticClass: "tab", attrs: { name: "localizacao" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Localização  ")
                  ]),
                  _vm.abaAtiva === "localizacao"
                    ? _c("localizacao-uc", {
                        attrs: { dadosJson: _vm.dadosJson }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fb54146", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fb54146","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/CadastroUc.vue
// module id = null
// module chunks = 